import { html, ref } from '@microsoft/fast-element';
import { QuadrantSpiderChart } from './quadrant-spider-chart';

export const QuadrantSpiderChartTemplate = html<QuadrantSpiderChart>`
  <div style="height: 100%;" ${ref('quadrantSpiderChart')}></div>
`;
